import { render, staticRenderFns } from "./RecordPlayer.vue?vue&type=template&id=5d65c1ef&scoped=true&"
import script from "./RecordPlayer.vue?vue&type=script&lang=js&"
export * from "./RecordPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RecordPlayer.vue?vue&type=style&index=0&id=5d65c1ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65c1ef",
  null
  
)

export default component.exports